import type { IPPAFilters } from '@/types/eos/filters'
import type { IPPAForm } from '@/types/eos/forms'
import type PPA from '@/types/eos/PPA'
import axios from 'axios'

export const getPPAs = async (filters: IPPAFilters): Promise<PPA[]> => {
  const res = await axios.get(`${import.meta.env.VITE_APP_PPAS_ENDPOINT}`, { params: filters })
  return res.data
}

export const deletePPA = async (ppaId: number) => {
  const res = await axios.delete(`${import.meta.env.VITE_APP_PPAS_ENDPOINT}/${ppaId}`)
  return res.data
}

export const createPPA = async (form: IPPAForm) => {
  const res = await axios.post(import.meta.env.VITE_APP_PPAS_ENDPOINT, form)
  return res.data
}
